<template>
  <div class="container">
    <el-card>
      <div class="filter-container">
        <span class="search-label">平台名称：</span>
        <el-input
          size="small"
          v-model="searchKeywords.name"
          placeholder="平台名称"
          style="width: 140px; margin-right: 20px"
        />
        
        <span class="search-label">所属机构：</span>
        <el-select
          size="small"
          v-model="searchKeywords.channel_id"
          placeholder="请选择所属机构"
          clearable
          filterable
          style="width: 200px; margin-right: 20px"
        >
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.alias"
            :value="item.id"
          />
        </el-select>

        <el-button size="small" @click="handleSearch">搜索</el-button>
        <el-button size="small" @click="handleShowAll">全部</el-button>

        <div class="right-buttons">
          <el-button size="small" type="primary" @click="handleAdd">添加</el-button>
        </div>
      </div>
    </el-card>

    <el-card style="margin-top: 15px">
      <el-table
        ref="table"
        border
        size="small"
        :data="tableData.rows"
        :height="tableHeight"
        :header-cell-style="{ backgroundColor: '#f7f7f7', color: '#333' }"
      >
        <el-table-column show-overflow-tooltip prop="id" label="平台Id" width="100" align="center" />
        <el-table-column show-overflow-tooltip prop="name" label="平台名称" width="120" align="center" />
        <el-table-column show-overflow-tooltip prop="agent_name" label="代理名称" width="120" align="center" />
        <el-table-column show-overflow-tooltip prop="channel_name" label="所属机构" width="150" align="center" />
        <el-table-column show-overflow-tooltip prop="appname" label="h5地址" width="500" align="center" :formatter="formatH5Url" />
        <el-table-column show-overflow-tooltip prop="app_key" label="App_Key" width="100" align="center" />
        <el-table-column show-overflow-tooltip prop="address" label="公司地址" width="350" align="center" />
        <el-table-column show-overflow-tooltip prop="service_phone" label="客服电话" width="120" align="center" />
        <el-table-column show-overflow-tooltip prop="disabled" label="状态" width="60" align="center" :formatter="formatStatus" />
        <el-table-column show-overflow-tooltip prop="created_at" label="创建时间" width="180" align="center" :formatter="formatDate" />
        <el-table-column show-overflow-tooltip prop="operator" label="操作人" width="80" align="center" />
        <el-table-column show-overflow-tooltip prop="note" label="备注" width="150" align="center" />
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="handleView(row)">查看</el-button>
            <template v-if="row.disabled">
              <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
              <el-button size="mini" type="success" @click="handleToggleStatus(row, false)">启用</el-button>
            </template>
            <template v-else>
              <el-button size="mini" disabled>编辑</el-button>
              <el-button size="mini" disabled>删除</el-button>
              <el-button size="mini" type="warning" @click="handleToggleStatus(row, true)">禁用</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="tableData.total"
        :page.sync="pagination.page"
        :rows.sync="pagination.rows"
        @pagination="handleGetList"
      />
    </el-card>

    <!-- 添加/编辑/查看对话框 -->
    <AppEditDialog
      :visible.sync="editVisible"
      :title="editTitle"
      :form-data="editFormData"
      :mode="editMode"
      @save="handleSave"
    />
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import AppEditDialog from './components/AppEditDialog.vue'
import { getAppList, deleteApp, toggleAppStatus, getChannelList } from '@/api/custom-frontend'

export default {
  name: 'CustomFrontendAppList',
  components: {
    pagination,
    AppEditDialog
  },
  data() {
    return {
      tableHeight: 400,
      searchKeywords: {
        name: '',
        channel_id: ''
      },
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      tableData: {
        rows: [],
        total: 0
      },
      channelList: [],
      editVisible: false,
      editTitle: '',
      editFormData: {},
      editMode: 'add' // add, edit, view
    }
  },
  mounted() {
    this.calculateTableHeight()
    this.handleGetList()
    this.getChannelList()
    window.addEventListener('resize', this.calculateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight)
  },
  methods: {
    calculateTableHeight() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight
        this.tableHeight = windowHeight - 200
      })
    },
    
    async handleGetList() {
      try {
        const params = {
          page: this.pagination.page,
          rows: this.pagination.rows
        }
        
        const res = await getAppList(params)
        if (res && res.err_code === 0) {
          this.tableData = res
          this.pagination.total = res.total
        }
      } catch (error) {
        console.error('获取App列表失败:', error)
      }
    },
    
    async getChannelList() {
      try {
        const res = await getChannelList()
        if (res && res.err_code === 0) {
          this.channelList = res.rows || []
        }
      } catch (error) {
        console.error('获取机构列表失败:', error)
      }
    },
    
    async handleSearch() {
      const params = {
        page: 1,
        rows: this.pagination.rows
      }
      
      if (this.searchKeywords.name) {
        params.name = this.searchKeywords.name
      }
      
      if (this.searchKeywords.channel_id) {
        params.channel_id = this.searchKeywords.channel_id
      }
      
      try {
        const res = await getAppList(params)
        if (res && res.err_code === 0) {
          this.tableData = res
          this.pagination.total = res.total
          this.pagination.page = 1
        }
      } catch (error) {
        console.error('搜索App列表失败:', error)
      }
    },
    
    handleShowAll() {
      this.searchKeywords = {
        name: '',
        channel_id: ''
      }
      this.pagination.page = 1
      this.handleGetList()
    },
    
    handleAdd() {
      this.editTitle = '添加平台'
      this.editFormData = {}
      this.editMode = 'add'
      this.editVisible = true
    },
    
    handleView(row) {
      this.editTitle = '查看平台'
      this.editFormData = { ...row }
      this.editMode = 'view'
      this.editVisible = true
    },
    
    handleEdit(row) {
      this.editTitle = '编辑平台'
      this.editFormData = { ...row }
      this.editMode = 'edit'
      this.editVisible = true
    },
    
    async handleDelete(row) {
      this.$confirm('确认删除吗？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteApp({ id: row.id })
          
          if (res && res.err_code === 0) {
            this.$message.success('删除成功')
            this.handleGetList()
          } else {
            this.$message.error(res.err_msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        // 取消删除
      })
    },
    
    async handleToggleStatus(row, disabled) {
      const action = disabled ? '禁用' : '启用'
      this.$confirm(`您确认想要${action}吗？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await toggleAppStatus({
            id: row.id,
            disabled: disabled
          })
          
          if (res && res.err_code === 0) {
            this.$message.success('操作成功')
            this.handleGetList()
          } else {
            this.$message.error(res.err_msg || '操作失败')
          }
        } catch (error) {
          console.error('操作失败:', error)
          this.$message.error('操作失败')
        }
      }).catch(() => {
        // 取消操作
      })
    },
    
    handleSave() {
      this.editVisible = false
      this.handleGetList()
    },
    
    // 格式化方法
    formatH5Url(value, row) {
      let appname = value.appname;
      
      if (!appname) return '-'
      
      // 根据环境和appname生成URL
      const isTestEnv = location.href.includes('localhost') || 
                       location.href.includes('test') || 
                       location.href.includes('127.0.0')
      
      let url = ''
      if (isTestEnv) {
        if (appname === 'SuperEcargo') {
          url = `http://test.rbbaotong.com/ecargo/#/home?appname=${appname}`
        } else {
          url = `http://test.rbbaotong.com/m/#/review?appname=${appname}`
        }
      } else {
        if (appname === 'SuperEcargo') {
          url = `http://jubao.limabaoxian.com/ecargo/#/home?appname=${appname}`
        } else {
          url = `http://jubao.limabaoxian.com/m/#/review?appname=${appname}`
        }
      }
      return url
    },
    
    formatStatus(value) {
      return value ? '禁用' : '启用'
    },
    
    formatDate(value) {
      let date = value.created_at;
      if (!date || +new Date(date) < 0) {
        return '-'
      }
      return this.$day(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .filter-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .search-label {
      margin-right: 10px;
      font-size: 14px;
    }
    
    .right-buttons {
      margin-left: auto;
      display: flex;
      align-items: center;
      
      .el-button {
        margin-left: 10px;
      }
    }
  }
}
</style>